export * from "./ComprehendClient";
export * from "./Comprehend";
export * from "./commands/BatchDetectDominantLanguageCommand";
export * from "./commands/BatchDetectEntitiesCommand";
export * from "./commands/BatchDetectKeyPhrasesCommand";
export * from "./commands/BatchDetectSentimentCommand";
export * from "./commands/BatchDetectSyntaxCommand";
export * from "./commands/ClassifyDocumentCommand";
export * from "./commands/CreateDocumentClassifierCommand";
export * from "./commands/CreateEndpointCommand";
export * from "./commands/CreateEntityRecognizerCommand";
export * from "./commands/DeleteDocumentClassifierCommand";
export * from "./commands/DeleteEndpointCommand";
export * from "./commands/DeleteEntityRecognizerCommand";
export * from "./commands/DescribeDocumentClassificationJobCommand";
export * from "./commands/DescribeDocumentClassifierCommand";
export * from "./commands/DescribeDominantLanguageDetectionJobCommand";
export * from "./commands/DescribeEndpointCommand";
export * from "./commands/DescribeEntitiesDetectionJobCommand";
export * from "./commands/DescribeEntityRecognizerCommand";
export * from "./commands/DescribeKeyPhrasesDetectionJobCommand";
export * from "./commands/DescribeSentimentDetectionJobCommand";
export * from "./commands/DescribeTopicsDetectionJobCommand";
export * from "./commands/DetectDominantLanguageCommand";
export * from "./commands/DetectEntitiesCommand";
export * from "./commands/DetectKeyPhrasesCommand";
export * from "./commands/DetectSentimentCommand";
export * from "./commands/DetectSyntaxCommand";
export * from "./commands/ListDocumentClassificationJobsCommand";
export * from "./pagination/ListDocumentClassificationJobsPaginator";
export * from "./commands/ListDocumentClassifiersCommand";
export * from "./pagination/ListDocumentClassifiersPaginator";
export * from "./commands/ListDominantLanguageDetectionJobsCommand";
export * from "./pagination/ListDominantLanguageDetectionJobsPaginator";
export * from "./commands/ListEndpointsCommand";
export * from "./commands/ListEntitiesDetectionJobsCommand";
export * from "./pagination/ListEntitiesDetectionJobsPaginator";
export * from "./commands/ListEntityRecognizersCommand";
export * from "./pagination/ListEntityRecognizersPaginator";
export * from "./commands/ListKeyPhrasesDetectionJobsCommand";
export * from "./pagination/ListKeyPhrasesDetectionJobsPaginator";
export * from "./commands/ListSentimentDetectionJobsCommand";
export * from "./pagination/ListSentimentDetectionJobsPaginator";
export * from "./commands/ListTagsForResourceCommand";
export * from "./commands/ListTopicsDetectionJobsCommand";
export * from "./pagination/ListTopicsDetectionJobsPaginator";
export * from "./commands/StartDocumentClassificationJobCommand";
export * from "./commands/StartDominantLanguageDetectionJobCommand";
export * from "./commands/StartEntitiesDetectionJobCommand";
export * from "./commands/StartKeyPhrasesDetectionJobCommand";
export * from "./commands/StartSentimentDetectionJobCommand";
export * from "./commands/StartTopicsDetectionJobCommand";
export * from "./commands/StopDominantLanguageDetectionJobCommand";
export * from "./commands/StopEntitiesDetectionJobCommand";
export * from "./commands/StopKeyPhrasesDetectionJobCommand";
export * from "./commands/StopSentimentDetectionJobCommand";
export * from "./commands/StopTrainingDocumentClassifierCommand";
export * from "./commands/StopTrainingEntityRecognizerCommand";
export * from "./commands/TagResourceCommand";
export * from "./commands/UntagResourceCommand";
export * from "./commands/UpdateEndpointCommand";
export * from "./pagination/Interfaces";
export * from "./models/index";
//# sourceMappingURL=index.js.map